import React, { useRef } from "react";
import  Table from '../base-table';
import type { TableRef } from '../base-table';
import type { ColumnDef, SortingState, ColumnFiltersState, ColumnOrderState, RowSelectionState } from "@tanstack/react-table";
import { getCoreRowModel } from "@tanstack/react-table";
import type { Exception } from "../../shared/Types";
import { Skeleton } from "@nike/eds";
// import { getTableColumns } from "./Columns";

interface ExceptionsTableProps {
  columns?: () => ColumnDef<Exception, any>[];
  data: Exception[];
  getRowId?: (originalRow: Exception) => string;
  
  state: {
    sorting: SortingState;
    columnFilters: ColumnFiltersState;
    setSorting: (newSorting: SortingState) => void;
    setColumnFilters: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
    columnOrder: ColumnOrderState;
    setColumnOrder: (newOrder: ColumnOrderState) => void;
    setRowSelection: (newRowSelection: RowSelectionState) => void;
    rowSelection?: RowSelectionState;
    resetRowSelection?: (defaultState?: boolean) => void;
    columnVisibility?: Record<string, boolean>;
    setColumnVisibility?: (newVisibility: Record<string, boolean>) => void;
  };
  isLoading: boolean;
  error: any;
}
export const ExceptionsTable = React.memo(
    function ExceptionsTable({ columns, data, state, isLoading, error, getRowId }: ExceptionsTableProps) {
    const tableRef = useRef<TableRef>(null);

    if (isLoading) return <Skeleton height={60} width={"100%"} />;
    if (error) return <div style={{ color: "red" }}>Error: {error.message}</div>;
    //TODO: the epic-tablecontainer needs to have overflow:auto to behave like the mockup when pagination is on

    if (data) {
        return (
            <div style={{ height: "100%" }}>
        <Table
            // className="exceptions-table"
            fullWidth
            ref={tableRef}
            columns={columns ? (columns() as any) : []}
            getCoreRowModel={getCoreRowModel()}
            data={data}
            enableSorting={true}
            disableStickyHeader={true}
            // enableExpanding={true}
            allowMultiSort={true}
            state={{
                columnFilters: state.columnFilters,
                sorting: state.sorting,
                columnOrder: state.columnOrder,
                // setSorting: state.setSorting,
                // setColumnFilters: state.setColumnFilters,
                setColumnOrder: state.setColumnOrder,
                rowSelection: state.rowSelection,
                columnVisibility: state.columnVisibility
            }}
            emptyState={{
            title: "No Exceptions Found",
            description: "There are no exceptions to display at this time.",
            }}
            onSortChange={state.setSorting}
            onColumnFiltersChange={state.setColumnFilters}
            manualPagination={true}
            manualFiltering={true}
            manualSorting={true}
            enableMultiRowSelection={false}
            onRowSelectionChange={state.setRowSelection}
            getRowId={getRowId}
            resetRowSelection={state.resetRowSelection}
            setColumnVisibility={state.setColumnVisibility}
        />
        </div>
        );
    }
    return <></>;
});

